import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { CartDesktopList, CartList, CartSum } from '@ui/cart';
import { useCart } from '@features/cart';
import { CartSubmitButton } from '../../entites/cart';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';
import { Line } from '@ui/common/line.tsx';
import { PopularProducts } from '@features/main';

export const CartPage = () => {
  const set = useNavbar();

  const { data, isLoadingSum, isShowControl, sum, count } = useCart();

  useEffect(() => {
    set.cart();
  }, []);
  return (
    <>
      <div className="container max-w-7xl lg:mx-auto">
        <div className="hidden lg:block mt-12">
          <Breadcrumbs>
            <BreadcrumbItem href="/">
              <Home2 size="24" color="#9CA5AC" />
            </BreadcrumbItem>
            <BreadcrumbItem color="primary">Корзина</BreadcrumbItem>
          </Breadcrumbs>
        </div>

        <div className="mt-6">
          <h1 className="hidden lg:inline text-4xl text-[#222222] font-bold">
            Корзина
          </h1>
        </div>
      </div>

      <div className="hidden lg:flex flex-row mt-12 min-h-[460px] container max-w-7xl mx-auto gap-x-[84px]">
        <div
          className={`flex-grow ${isShowControl ? 'max-w-[760px] pb-12' : ''}`}
        >
          <CartDesktopList items={data} />
        </div>

        {isShowControl && (
          <div className="w-[430px] flex flex-col gap-y-6">
            <CartSum sum={sum} count={count} isLoading={isLoadingSum} />

            <CartSubmitButton />
          </div>
        )}
      </div>

      <div className={`w-full lg:hidden ${isShowControl ? '' : 'h-full'}`}>
        <CartList isDivided items={data} />
      </div>

      <Line isDesktop />

      <div className="hidden lg:block container max-w-7xl mx-auto pb-32">
        <PopularProducts />
      </div>

      {isShowControl && (
        <div className="py-6 lg:hidden">
          <CartSum sum={sum} count={count} isLoading={isLoadingSum} />
        </div>
      )}

      <div className="lg:hidden">{isShowControl && <CartSubmitButton />}</div>
    </>
  );
};
